import React, { useCallback, useState, useRef, useEffect } from 'react';
import { connect } from "react-redux";
import { useHistory } from 'react-router-dom';
import { Button } from 'devextreme-react/button';
import AccordionReact from 'devextreme-react/accordion';
import FormField from '../../../dynamicFormBuilder/FormField';
import Toolbar, { Item } from "devextreme-react/toolbar";
import '../../../common/css/searchPage.css';
import { createStore } from 'devextreme-aspnet-data-nojquery';
import DataSource from "devextreme/data/data_source";
import data from "../../../assets/apiRoutes.json";
import { GridLayout } from "../../../common/GridLayout";
import {
  Column,
  DataGrid,
  Scrolling,
  FilterRow,
  HeaderFilter,
  FilterPanel,
  Sorting,
  Paging,
  Toolbar as GridToolbar,
  Item as GridToolbarItem,
  Export,
  Pager,
  ColumnChooser,
  ColumnChooserSearch,
  StateStoring,
  ColumnHeaderFilter,
  Selection,
  GroupPanel,
  Grouping,
} from "devextreme-react/data-grid";
import { FillFilters, buildDxFilters } from '../../../common/Utils';

const searchpanel = [
  {
    ID: 1,
    Title: 'Search Filters'
  }
];

const SearchLayout = [
  {
    "groupId": 1,
    "fields": [
      {
        "name": "R_CUSTOMER",
        "tableName": "WMTRANSACTIONHEADER",
        "label": "Customer",
        "type": "text",
        "options": null,
        "apiUrl": null,
        "grid": null,
        "required": false,
        "visible": true,
        "isLabelChanged": false,
      },
      {
        "name": "TRANSACTIONNUMBER",
        "tableName": "WMTRANSACTIONHEADER",
        "label": "Transaction #",
        "type": "text",
        "options": null,
        "apiUrl": null,
        "grid": null,
        "required": false,
        "visible": true,
        "isLabelChanged": false,
      }
    ]
  },
  {
    "groupId": 2,
    "fields": [
      {
        "name": "TRANSACTIONTYPE",
        "tableName": "WMTRANSACTIONHEADER",
        "label": "Type",
        "type": "select",
        "options": [],
        "apiUrl": null,
        "grid": null,
        "required": false,
        "visible": true,
        "isLabelChanged": false,
      },
      {
        "name": "STATUS",
        "tableName": "WMTRANSACTIONHEADER",
        "label": "Status",
        "type": "select",
        "options": [],
        "apiUrl": null,
        "grid": null,
        "required": false,
        "visible": true,
        "isLabelChanged": false,
      }
    ]
  },
  {
    "groupId": 3,
    "fields": [
      {
        "name": "RECORDNUMBER",
        "tableName": "WMTRANSACTIONHEADER",
        "label": "Record #",
        "type": "text",
        "options": null,
        "apiUrl": null,
        "grid": null,
        "required": false,
        "visible": true,
        "isLabelChanged": false,
      },
      {
        "name": "REFERENCE",
        "tableName": "WMTRANSACTIONHEADER",
        "label": "PO/Reference",
        "type": "text",
        "options": null,
        "apiUrl": null,
        "grid": null,
        "required": false,
        "visible": true,
        "isLabelChanged": false,
      }
    ]
  }
];

const initialFormFields = {
  R_CUSTOMER: '',
  TRANSACTIONNUMBER: '',
  TRANSACTIONTYPE: '',
  STATUS: '',
  RECORDNUMBER: '',
  REFERENCE: '',
};

const SearchCharges = (props) => {
  const history = useHistory();
  const dataGrid = useRef(null);
  var accessToken = props.oidc.user.access_token;
  var currentUser = props.oidc.user;
  const DYNAMICFORMSETTING = props.oidc?.user?.profile?.DYNAMICFORMSETTING;
  const [formFields, setformFields] = useState(initialFormFields);
  const formRefs = useRef({});
  const [selectedItems, setSelectedItems] = useState([]);
  const [searchPanelStatus, setSearchPanelStatus] = useState(false);
  const [selectedRowId, setSelectedRowId] = useState(null);
  const [resultData, setResultData] = useState(null);

  const allowedPageSizes = [10, 20, 100, 500, 1000, "all"];
  const gridKey = "A9CC5D33-F188-44FD-87CB-08DDC3A6F610";
  const [currentLayout, setCurrentLayout] = useState("Default");
  const loadState = useCallback(() => { return GridLayout.sendStorageRequest(gridKey, "GET", accessToken, null, currentLayout); }, [currentLayout, accessToken]);
  const saveState = useCallback((state) => { GridLayout.sendStorageRequest(gridKey, "POST", accessToken, state, currentLayout); }, [gridKey, currentLayout, accessToken]);

  const loadDatasource = () => {
    let store = createStore({
      key: 'Rowid',
      loadParams: formFields,
      loadUrl: `${window._env_.REACT_APP_APIS}/${data.Transaction.GetStorageMiscellaneousTransactions}`,
      onBeforeSend: (method, ajaxOptions) => {
        ajaxOptions.headers = {
          access_token: accessToken,
          Authorization: `Bearer ${accessToken}`,
        };
      },
    });
    const dataSource = new DataSource({ store: store });
    return dataSource;
  }

  const handleSearch = (e) => {
    e.event.stopPropagation();
    let datasource = loadDatasource();
    const { IDTYPE, ...filteredFormFields } = formFields;
    
    // Build filters using buildDxFilters to handle different field types properly
    const filterLayout = {
      TRANSACTIONTYPE: 'select',
      STATUS: 'select',
      R_CUSTOMER: 'text',
      TRANSACTIONNUMBER: 'text',
      RECORDNUMBER: 'text',
      REFERENCE: 'text'
    };
    
    const filters = buildDxFilters(filteredFormFields, filterLayout);
    
    // Map TRANSACTIONTYPE to transType field for filtering (since DTO uses transType for raw value)
    const transactionTypeIndex = filters.findIndex(f => Array.isArray(f) && f[0] === 'TRANSACTIONTYPE');
    if (transactionTypeIndex >= 0) {
      filters[transactionTypeIndex][0] = 'transType';
    }
    


    
    // Map STATUS to transStatus field for filtering (since DTO uses transStatus for raw value)
    const statusIndex = filters.findIndex(f => Array.isArray(f) && f[0] === 'STATUS');
    if (statusIndex >= 0) {
      filters[statusIndex][0] = 'transStatus';
    }
    
    // Map R_CUSTOMER to customerIdentityId field for filtering
    const customerIndex = filters.findIndex(f => Array.isArray(f) && f[0] === 'R_CUSTOMER');
    if (customerIndex >= 0) {
      filters[customerIndex][0] = 'customerIdentityId';
    }
    
    // Map TRANSACTIONNUMBER to transactionNumber field for filtering
    const transactionNumberIndex = filters.findIndex(f => Array.isArray(f) && f[0] === 'TRANSACTIONNUMBER');
    if (transactionNumberIndex >= 0) {
      filters[transactionNumberIndex][0] = 'transactionNumber';
    }
    
    // Map RECORDNUMBER to record field for filtering
    const recordNumberIndex = filters.findIndex(f => Array.isArray(f) && f[0] === 'RECORDNUMBER');
    if (recordNumberIndex >= 0) {
      filters[recordNumberIndex][0] = 'record';
    }
    
     
    
    datasource.filter(filters);
    setResultData(datasource);
    
     
  }

  const handleReset = (e) => {
    e.event.stopPropagation();
    setformFields(initialFormFields);
  }

  useEffect(() => {
    setResultData(loadDatasource());
  }, [formFields]);

  const handleCreate = () => {
    history.push('/wm/charges/create-charges');
  }

  const handleEdit = () => {
    if (selectedRowId) {
      history.push(`/wm/charges/edit-charges?id=${selectedRowId}`);
    }
  }

  const onSelectionChanged = (e) => {
    if (e.selectedRowsData && e.selectedRowsData.length === 1) {
      setSelectedRowId(e.selectedRowsData[0].Rowid || e.selectedRowsData[0].rowid);
    } else {
      setSelectedRowId(null);
    }
  }

  const selectionChanged = useCallback(
    (e, tg) => {
      let newItems = [...selectedItems];
      e.removedItems.forEach((item) => {
        const index = newItems.indexOf(item);
        if (index >= 0) {
          newItems.splice(index, 1);
        }
      });
      if (e.addedItems.length) {
        newItems = [...newItems, ...e.addedItems];
      }
      setSelectedItems(newItems);
      setSearchPanelStatus((prevStatus) => {
        const newStatus = !prevStatus;
        return newStatus;
      });
    },
    [selectedItems, setSelectedItems],
  );

  const handleFormLoad = useCallback(() => {
    var transactionTypes = [
      { "id": "C", "text": "Storage" },
      { "id": "M", "text": "Miscellaneous" }
    ];
    loadLookupClient("TRANSACTIONTYPE", transactionTypes);

    var status = [
      { "id": "O", "text": "Open" },
      { "id": "H", "text": "Hold" },
      { "id": "L", "text": "Ready To Commit Later" },
      { "id": "Z", "text": "Committed" }
    ];
    loadLookupClient("STATUS", status);
  }, [accessToken]);

  const loadLookupClient = (name, data) => {
    try {
      if (formRefs.current[name]) {
        formRefs.current[name].instance().option('dataSource', data);
        formRefs.current[name].instance().option('valueExpr', 'id');
        formRefs.current[name].instance().option('displayExpr', 'text');
        if (formFields[name])
          formRefs.current[name].instance().option('value', formFields[name]);
      }
    }
    catch (error) {
      console.error('Error loading lookup:', error);
    }
  };

  const handleFieldChange = useCallback((name, value) => {
    // Handle field changes if needed
  }, []);

  return (
    <div className="search-page-container">
      <div className="search-page-content">
        <div id="accordion" className="search-page-accordion">
          <AccordionReact
            dataSource={searchpanel}
            collapsible={true}
            multiple={false}
            animationDuration={300}
            selectedItems={selectedItems}
            onSelectionChanged={e => {
              if (e.currentTarget === e.target) {
                selectionChanged(e, e.target);
              }
            }}
            itemTitleRender={() => (
              <Toolbar className="accordian-toolbar">
                <Item location="before">
                  <div className="title">
                    <h6
                      style={{
                        color: window._env_.Color2
                      }}
                    >
                      Enter Your Query For Search Charges
                    </h6>
                  </div>
                </Item>
                <Item location="after">
                  <Button className="accordianButton" onClick={handleSearch} text="Search" type="default" />
                </Item>
                <Item location="after">
                  <Button className="accordianButton" onClick={handleReset} text="Reset" />
                </Item>
              </Toolbar>
            )}
            itemRender={(itemProps) => (
              <FormField
                currrentUser={currentUser}
                layoutId='62418e8e-774a-436e-84f9-174df00a62b4'
                layoutName='SearchChargesSearchForm'
                defaultFormSchema={SearchLayout}
                formFields={formFields}
                setformFields={setformFields}
                handleFieldValueChange={handleFieldChange}
                DYNAMICFORMSETTING={DYNAMICFORMSETTING}
                formRefs={formRefs}
                onFormLoad={handleFormLoad}
                noSpacingBeforeFirstRow={true}
              />
            )}
            id="accordion-container"
            className="accordion-height"
          />
        </div>
        <div className="search-page-grid-container">
          <DataGrid
            onExporting={(e) => {
              if (window.handleDevExtremeDataGridExport) {
                window.handleDevExtremeDataGridExport(e);
              }
            }}
            ref={dataGrid}
            allowColumnReordering={true}
            allowColumnResizing={true}
            dataSource={resultData}
            showBorders={true}
            hoverStateEnabled={true}
            className="search-page-grid"
            onSelectionChanged={(e) => onSelectionChanged(e)}
            remoteOperations={true}
            searchEnabled={true}
            columnAutoWidth={true}
          >
            <ColumnChooser
              enabled={true}
              title="Choose Column"
              width={290}
              height={290}
              sortOrder="asc"
            >
              <ColumnChooserSearch
                enabled={true}
                editorOptions={{ placeholder: 'Search column' }} />
            </ColumnChooser>
            <Export enabled={true} allowExportSelectedData={true} />
            <Selection mode="multiple" />
            <Sorting visible={true} mode="multiple" />
            <Paging defaultPageSize={10} />
            <Pager
              visible={true}
              showPageSizeSelector={true}
              allowedPageSizes={allowedPageSizes}
              showNavigationButtons={true}
            />
            <FilterRow visible={true} />
            <FilterPanel visible={true} />
            <GroupPanel visible={true} />
            <Grouping autoExpandAll={false} />
            <StateStoring
              enabled={true}
              type="custom"
              customLoad={loadState}
              storageKey={gridKey}
              customSave={saveState}
            />
            <Column dataField="record" caption="Record #" calculateCellValue={(rowData) => rowData.record || ''}></Column>
            <Column dataField="TransactionNumber" caption="Transaction #" calculateCellValue={(rowData) => rowData.TransactionNumber || ''}></Column>
            <Column dataField="CustomerIdentityId" caption="Customer" calculateCellValue={(rowData) => rowData.CustomerIdentityId || ''}></Column>
            <Column dataField="CustomerName" caption="Name" calculateCellValue={(rowData) => rowData.CustomerName || ''}></Column>
            <Column dataField="TransactionType" caption="Type" calculateCellValue={(rowData) => rowData.TransactionType || rowData.transType || ''}></Column>
            <Column dataField="TransactionDate" caption="Transaction Date" dataType="date" calculateCellValue={(rowData) => rowData.TransactionDate || null}></Column>
            <Column dataField="Status" caption="Status" calculateCellValue={(rowData) => rowData.Status || rowData.transStatus || ''}></Column>
            <Column dataField="Stage" caption="Stage" calculateCellValue={(rowData) => rowData.Stage || ''}></Column>
            <Column dataField="ActualReceivedShippedDateTime" caption="Actual" dataType="datetime" visible={false}></Column>
            <Column dataField="TruckArrivalDateTime" caption="Arrival" dataType="datetime" visible={false}></Column>
            <Column dataField="TruckDepartDateTime" caption="Depart" dataType="datetime" visible={false}></Column>
            <Column dataField="Amount" caption="Amount" dataType="number" format="currency" visible={false}></Column>
            <Column dataField="FreightAmount" caption="Freight Amount" dataType="number" format="currency" visible={false}></Column>
            <Column dataField="CodAmount" caption="COD Amount" dataType="number" format="currency" visible={false}></Column>
            <Column dataField="TaxAmount" caption="Tax Amount" dataType="number" format="currency" visible={false}></Column>
            <Column dataField="UserDefinedCode1" caption="Code 1" visible={false}></Column>
            <Column dataField="UserDefinedCode2" caption="Code 2" visible={false}></Column>
            <Column dataField="UserDefinedCode3" caption="Code 3" visible={false}></Column>
            <Column dataField="UserDefinedCode4" caption="Code 4" visible={false}></Column>
            <Column dataField="UserDefinedCode5" caption="Code 5" visible={false}></Column>
            <Column dataField="UserDefinedCode6" caption="Code 6" visible={false}></Column>
            <Column dataField="UserDefinedCode7" caption="Code 7" visible={false}></Column>
            <Column dataField="UserDefinedCode8" caption="Code 8" visible={false}></Column>
            <Column dataField="UserDefinedCode9" caption="Code 9" visible={false}></Column>
            <Column dataField="UserDefinedCode10" caption="Code 10" visible={false}></Column>
            <Column dataField="CodAmountCollected" caption="Collected" dataType="number" format="currency" visible={false}></Column>
            <Column dataField="CommitDate" caption="Commit Date" dataType="date" visible={false}></Column>
            <Column dataField="ConsolidateInvoiceFlag" caption="Consolidate" visible={false}></Column>
            <Column dataField="Container" caption="Container #" visible={false}></Column>
            <Column dataField="CreationDateTime" caption="Creation Date/Time" dataType="datetime" visible={false}></Column>
            <Column dataField="CreationUserId" caption="Creation User ID" visible={false}></Column>
            <Column dataField="UserDefinedDate1" caption="Date 1" dataType="date" visible={false}></Column>
            <Column dataField="UserDefinedDate2" caption="Date 2" dataType="date" visible={false}></Column>
            <Column dataField="UserDefinedDate3" caption="Date 3" dataType="date" visible={false}></Column>
            <Column dataField="UserDefinedDate4" caption="Date 4" dataType="date" visible={false}></Column>
            <Column dataField="UserDefinedDate5" caption="Date 5" dataType="date" visible={false}></Column>
            <Column dataField="UserDefinedDate6" caption="Date 6" dataType="date" visible={false}></Column>
            <Column dataField="UserDefinedDate7" caption="Date 7" dataType="date" visible={false}></Column>
            <Column dataField="UserDefinedDate8" caption="Date 8" dataType="date" visible={false}></Column>
            <Column dataField="UserDefinedDate9" caption="Date 9" dataType="date" visible={false}></Column>
            <Column dataField="UserDefinedDate10" caption="Date 10" dataType="date" visible={false}></Column>
            <Column dataField="DeliveryPickupDepartDateTime" caption="Departure" dataType="datetime" visible={false}></Column>
            <Column dataField="DispatchOrderNumber" caption="Dispatch #" visible={false}></Column>
            <Column dataField="FiscalPeriod" caption="Fiscal Period" visible={false}></Column>
            <Column dataField="FiscalYear" caption="Fiscal Year" visible={false}></Column>
            <Column dataField="DeliveryPickupFlag" caption="Flag" visible={false}></Column>
            <Column dataField="HoldReason" caption="Hold Reason" visible={false}></Column>
            <Column dataField="ConsolidatedInvoice" caption="Invoice Code" visible={false}></Column>
            <Column dataField="LastUpdateDateTime" caption="Last Update Date/Time" dataType="datetime" visible={false}></Column>
            <Column dataField="LastUpdateUserId" caption="Last Update User ID" visible={false}></Column>
            <Column dataField="TransportationMode" caption="Mode" visible={false}></Column>
            <Column dataField="CodPayMethod" caption="Pay Method" visible={false}></Column>
            <Column dataField="PickStatus" caption="Pick Status" visible={false}></Column>
            <Column dataField="PrintPickingSlip" caption="Picking Slip" visible={false}></Column>
            <Column dataField="PlannedReceivedShippedDateTime" caption="Planned" dataType="datetime" visible={false}></Column>
            <Column dataField="Reference" caption="PO/Reference" visible={false}></Column>
            <Column dataField="PrintBol" caption="Print BOL" visible={false}></Column>
            <Column dataField="PrintLabel" caption="Print Label" visible={false}></Column>
            <Column dataField="PrintReceipt" caption="Print Receipt" visible={false}></Column>
            <Column dataField="UserDefinedQuantity1" caption="Quantity 1" dataType="number" visible={false}></Column>
            <Column dataField="UserDefinedQuantity2" caption="Quantity 2" dataType="number" visible={false}></Column>
            <Column dataField="UserDefinedQuantity3" caption="Quantity 3" dataType="number" visible={false}></Column>
            <Column dataField="UserDefinedQuantity4" caption="Quantity 4" dataType="number" visible={false}></Column>
            <Column dataField="UserDefinedQuantity5" caption="Quantity 5" dataType="number" visible={false}></Column>
            <Column dataField="UserDefinedQuantity6" caption="Quantity 6" dataType="number" visible={false}></Column>
            <Column dataField="UserDefinedQuantity7" caption="Quantity 7" dataType="number" visible={false}></Column>
            <Column dataField="UserDefinedQuantity8" caption="Quantity 8" dataType="number" visible={false}></Column>
            <Column dataField="UserDefinedQuantity9" caption="Quantity 9" dataType="number" visible={false}></Column>
            <Column dataField="UserDefinedQuantity10" caption="Quantity 10" dataType="number" visible={false}></Column>
            <Column dataField="UserDefinedReference1" caption="Reference 1" visible={false}></Column>
            <Column dataField="UserDefinedReference2" caption="Reference 2" visible={false}></Column>
            <Column dataField="UserDefinedReference3" caption="Reference 3" visible={false}></Column>
            <Column dataField="UserDefinedReference4" caption="Reference 4" visible={false}></Column>
            <Column dataField="UserDefinedReference5" caption="Reference 5" visible={false}></Column>
            <Column dataField="UserDefinedReference6" caption="Reference 6" visible={false}></Column>
            <Column dataField="UserDefinedReference7" caption="Reference 7" visible={false}></Column>
            <Column dataField="UserDefinedReference8" caption="Reference 8" visible={false}></Column>
            <Column dataField="UserDefinedReference9" caption="Reference 9" visible={false}></Column>
            <Column dataField="UserDefinedReference10" caption="Reference 10" visible={false}></Column>
            <Column dataField="SendFax" caption="Send Fax" visible={false}></Column>
            <Column dataField="ShipperBolNumber" caption="Shippers #" visible={false}></Column>
            <Column dataField="TaxBasis" caption="Taxbasis" visible={false}></Column>
            <Column dataField="TaxRate" caption="Taxrate" dataType="number" visible={false}></Column>
            <Column dataField="ThirdPartyBillType" caption="Thirdpartybillt" visible={false}></Column>
            <Column dataField="TransferToDispatch" caption="To Dispatch" visible={false}></Column>
            <Column dataField="TruckReference" caption="Truck/Driver" visible={false}></Column>
            <GridToolbar>
              <GridToolbarItem location="before">
                <Button
                  text="Edit"
                  type="default"
                  onClick={handleEdit}
                  disabled={!selectedRowId}
                />
              </GridToolbarItem>
              <GridToolbarItem location="before">
                <Button
                  text="Create"
                  type="default"
                  onClick={handleCreate}
                />
              </GridToolbarItem>
              <GridToolbarItem name="exportButton" />
              <GridToolbarItem name="columnChooserButton" />
            </GridToolbar>
          </DataGrid>
        </div>
      </div>
    </div>
  );
};

function mapStateToProps(state) {
  return {
    oidc: state.oidc
  };
}

export default connect(mapStateToProps)(SearchCharges);
